/**
 * InAppBrowser Configuration Constants
 *
 * Defines configuration options for the Cordova InAppBrowser plugin used during
 * OAuth authentication flows. These settings optimize security and user experience
 * across iOS and Android platforms.
 */

import { InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser';

/**
 * InAppBrowser configuration optimized for OAuth authentication
 *
 * These options provide a secure, streamlined authentication experience:
 * - Hides browser UI elements that aren't needed for auth flows
 * - Clears cache/session data to prevent auth conflicts
 * - Includes platform-specific optimizations for iOS and Android
 */
export const IN_APP_BROWSER_OPTIONS: InAppBrowserOptions = {
  // UI Configuration
  location: 'no', // Hide address bar for cleaner UX
  toolbar: 'no', // Hide navigation toolbar
  closebuttoncaption: 'Close', // Customize close button text

  // Security & Cache Management
  clearcache: 'yes', // Clear cache on each login to prevent stale auth state
  clearsessioncache: 'yes', // Clear session cache to prevent auth conflicts

  // UX Enhancements
  disallowoverscroll: 'yes', // Prevent rubber-band scrolling on iOS

  // Android-specific Options
  hardwareback: 'yes', // Enable hardware back button functionality
  mediaPlaybackRequiresUserAction: 'no', // Allow auto-play if needed
  shouldPauseOnSuspend: 'no', // Keep browser active during app suspension

  // Prevent auto-close on JavaScript errors (important for flaky Keycloak themes)
  hidenavigationbuttons: 'no', // Keep navigation visible for user control
  hideurlbar: 'no' // Keep URL bar for debugging purposes
};
